function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.019 2.187L1.845 0l9.128 10.933-9.128 10.933-1.826-2.187 7.246-8.746L.019 2.187z",
  fill: "#fff"
});

function SvgArrowRightCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrowRightCalendar;